import { useCallback } from 'react';
import type { QueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';
import { MUSIC_TAGS_CATALOG_QUERY_KEY } from '@/lib/readersCatalogQueryCache';
import { FONOTEKA_QUERY_KEY } from '@/features/fonoteka/queryKeys';
import { groupMusicTagsByGroup } from '@/lib/readerTagCatalogGrouping';
import { CatalogTagsCatalogModal } from '@/components/CatalogTagsCatalogModal/CatalogTagsCatalogModal';

export interface MusicTagsCatalogModalProps {
  open: boolean;
  onClose: () => void;
}

export function MusicTagsCatalogModal({ open, onClose }: MusicTagsCatalogModalProps) {
  const onInvalidateAfterMutation = useCallback(async (qc: QueryClient) => {
    await qc.invalidateQueries({ queryKey: MUSIC_TAGS_CATALOG_QUERY_KEY });
    await qc.invalidateQueries({ queryKey: FONOTEKA_QUERY_KEY });
  }, []);

  return (
    <CatalogTagsCatalogModal
      open={open}
      onClose={onClose}
      title="Теги фонотеки"
      queryKey={MUSIC_TAGS_CATALOG_QUERY_KEY}
      fetchTags={() => api.musicTags.list()}
      tagApi={api.musicTags}
      onInvalidateAfterMutation={onInvalidateAfterMutation}
      groupTags={groupMusicTagsByGroup}
      catalogKind="music"
      deleteGroupScopeNote="также у всех проектов с фонотекой"
      deleteTagScopeNote="убран у всех проектов с фонотекой"
    />
  );
}
